import { referentialEnumToReferentialCodeList } from "@pharmupp/p3-front-commons"

export const locationsConf = {
  CITY_CENTER_LARGE_METROPOLIS: { label: "Centre ville de grande métropole" },
  PERIPHERAL_NEIGHBORHOOD_RETIRED_POPULATION: {
    label: "Quartier périphérique à population retraité",
  },
  SENSITIVE_URBAN_ZONE: { label: "Zone Urbaine sensible" },
  AGRICULTURAL_RURAL: { label: "Rural agricole" },
  COMMERCIAL_ZONE: { label: "Zone commerciale" },
  STUDENT_TOWN_CENTER: { label: "Centre ville étudiant" },
  RURBAN: { label: "Rurbain" },
  RURAL_ACTIVE: { label: "Rural actif" },
  TOURIST_AREA: { label: "Zone touristique" },
  STATION: { label: "Gare" },
  ROAD_NETWORKS_BORDERS: { label: "réseaux routiers et frontières" },
  ACTIVE_CITY_CENTER: { label: "Centre ville actif" },
  TOWN: { label: "Bourg" },
  INDUSTRIAL_ZONE: { label: "Zone industrielle" },
  PASSING_PHARMACY: { label: "Pharmacie de passage" },
}

export const locationsReferential =
  referentialEnumToReferentialCodeList(locationsConf)
